import { grey } from '@material-ui/core/colors';
import { ru } from 'locale';

export const initialColumns = [
  { dataKey: 'name', label: '', width: 180 },
  { dataKey: 'code', label: ru.code, width: 80, style: { color: grey[500] } },
];

export const accountingSections = [
  {
    name: ru.balanceSheet,
    tables: [
      {
        headerName: `${ru.form} №1`,
        codes: [1600],
      },
      {
        headerName: ru.nonCurrentAssets,
        codes: [1150, 1160, 1170, 1180, 1190, 1100],
      },
      {
        headerName: ru.currentAssets,
        codes: [1210, 1220, 1230, 1240, 1250, 1260, 1200],
      },
      {
        headerName: ru.capitalAndReserves,
        codes: [1310, 1370, 1300],
      },
      {
        headerName: ru.longTermLiabilities,
        codes: [1410, 1420, 1400],
      },
      {
        headerName: ru.shortTermLiabilities,
        codes: [1510, 1520, 1540, 1500],
      },
    ],
  },
  {
    name: ru.incomeStatement,
    tables: [
      {
        headerName: ru.activityRevenuesAndExpenses,
        codes: [2110, 2120, 2100, 2210, 2220, 2200],
      },
      {
        headerName: ru.otherRevenuesAndExpenses,
        codes: [2320, 2330, 2340, 2350, 2300, 2410, 2421, 2430, 2450, 2460, 2400],
      },
      {
        headerName: ru.financeReference,
        codes: [2500],
      },
    ],
  },
];
